import { asNumber } from './detailShared'
// ADDENDUM 44 (E50) — los avisos que acompañan al estado en la lista de Workflow.
//
// Viven fuera del componente porque son REGLAS, no pintura: cada una afirma algo sobre la
// operación, y una regla que afirma algo falso en una fila lo afirma en todas las que se le
// parezcan. Aquí se pueden leer solas y probar solas.

/**
 * «Sin reportar» — queda tiempo planificado sin consumir y no se ha reportado nada dentro de él.
 *
 * ⚠️⚠️ ESTA REGLA SALE DE LAS PALABRAS DEL PO, NO DE SU MOCKUP, y las dos no coinciden. El dibujo
 * pone esta píldora en una fila cuyo tiempo va PASADO del teórico ("1m 07s · +1m 04s", o sea
 * teórico 3 s y real 67 s), donde por definición no queda margen. Preguntado, el PO lo describió
 * como «cuando aún hay tiempo libre/pendiente que entra dentro de lo planificado y no se ha
 * reportado nada ahí dentro», que es lo contrario de esa fila. Manda la frase: un mockup enseña
 * una forma, y los números de un boceto suelen ser de relleno. Queda anotado para que quien vea la
 * discrepancia sepa que se detectó y no que se pasó por alto.
 *
 * Lo que afirma, exactamente:
 *   · el teórico y el real están los dos (si falta uno no hay margen que calcular, y un margen que
 *     no se puede calcular NO es un margen de cero);
 *   · el real todavía no ha llegado al teórico, o sea que queda tiempo dentro de lo planificado;
 *   · y en ese margen no se ha reportado nada — `quantityDone` ausente o cero.
 *
 * ⚠️ `quantityDone` AUSENTE Y `quantityDone` A CERO CUENTAN IGUAL AQUÍ, y es la única parte de este
 * módulo donde se juntan dos cosas que en el resto de la ficha se separan. El aviso no habla del
 * dato sino del hecho: no hay nada reportado, tanto si el contador dice 0 como si no llegó. Lo que
 * NO hace es al revés — no dice nada cuando no puede saberlo, que es el caso de arriba.
 */
export const hasUnreportedSlack = (row) => {
  const source = row || {}
  const theoretical = asNumber(source.theoreticalDurationSeconds)
  const actual = asNumber(source.actualDurationSeconds)
  if (theoretical === null || actual === null) return false
  if (actual >= theoretical) return false
  const done = asNumber(source.quantityDone)
  return done === null || done === 0
}

/**
 * Cuántas incidencias abiertas, o `0`. Solo para decidir si el aviso se pinta: la cifra que se
 * enseña sale del mismo campo, sin pasar por aquí.
 *
 * ⚠️ Ausente devuelve 0 A PROPÓSITO, y no contradice a RN8: esto no PINTA un cero, decide si hay
 * algo que avisar. "No sé cuántas hay" no es motivo para gritar. La ausencia se sigue declarando
 * en la columna de cifras, que es donde se lee el dato.
 */
export const openIncidences = (row) => asNumber((row || {}).openIncidenceCount) || 0
